import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import useTranslate from '@sprinx/react-globalize/useTranslate';
import { makeStyles } from '@material-ui/core/styles';
import { pickHTMLProps } from 'pick-react-known-prop';
import TextFieldPreview from '@sprinx/react-mui-fields/TextFieldPreview';
import NumberFieldPreview from '@sprinx/react-mui-fields/NumberFieldPreview';
import DateFieldPreview from '@sprinx/react-mui-fields/DateFieldPreview';
import PercentFieldPreview from '@sprinx/react-mui-fields/PercentFieldPreview';
var useStyles = makeStyles(function (theme) {
  return {
    root: _defineProperty({
      display: 'flex'
    }, theme.breakpoints.down('sm'), {
      flexWrap: 'wrap'
    }),
    field: _defineProperty({
      width: 'auto',
      paddingRight: theme.spacing(2)
    }, theme.breakpoints.down('sm'), {
      paddingLeft: theme.spacing(2)
    })
  };
}, {
  name: 'SxComProductParametersInline'
});

function ProductParametersInline(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      pComponentMap = _ref.componentMap,
      ComponentProps = _ref.ComponentProps,
      parameters = _ref.parameters,
      rest = _objectWithoutProperties(_ref, ["classes", "className", "componentMap", "ComponentProps", "parameters"]);

  var t = useTranslate();
  var classes = useStyles({
    classes: pClasses
  });

  var componentMap = _extends({
    string: TextFieldPreview,
    number: NumberFieldPreview,
    date: DateFieldPreview,
    percent: PercentFieldPreview
  }, pComponentMap);

  var getParameterComponent = function getParameterComponent(parameter) {
    if (parameter.value instanceof Date) return componentMap.date;

    if (typeof parameter.value === 'number') {
      // TODO: how to resolve percent value
      return componentMap.number;
    }

    return componentMap.string;
  };

  return /*#__PURE__*/React.createElement("div", _extends({}, pickHTMLProps(rest), {
    className: clsx(classes.root, className)
  }), parameters.map(function (parameter, idx) {
    var ValueComponent = getParameterComponent(parameter);
    return /*#__PURE__*/React.createElement(ValueComponent, _extends({
      className: classes.field,
      key: idx.toString(),
      label: t(parameter.label, {
        acceptString: true
      }),
      value: "".concat(parameter.value, " ").concat(parameter.unit || ''),
      size: "small",
      color: "textSecondary"
    }, ComponentProps));
  }));
}

ProductParametersInline.propTypes = {
  classes: PropTypes.shape({
    field: PropTypes.string,
    root: PropTypes.string
  }),
  className: PropTypes.string,
  componentMap: PropTypes.shape({
    date: PropTypes.elementType,
    number: PropTypes.elementType,
    percent: PropTypes.elementType,
    string: PropTypes.elementType
  }),
  ComponentProps: PropTypes.shape({}),
  naked: PropTypes.bool,
  NumberFieldComponent: PropTypes.elementType,
  parameters: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.shape({}))]),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })),
  TextFieldComponent: PropTypes.elementType
};
ProductParametersInline.defaultProps = {
  classes: undefined,
  className: undefined,
  componentMap: undefined,
  ComponentProps: undefined,
  naked: false,
  NumberFieldComponent: undefined,
  parameters: [],
  TextFieldComponent: undefined
};
export default ProductParametersInline;